import type {
  ConstraintCtx,
  ConstraintResult,
  DragConstraint,
} from '../extensions/index.js';
import type { BarState } from '../extensions/types.js';

/**
 * Enforces that a bar's start is strictly before (or equal to) its end.
 *
 * On `move`/`create` the proposal is rejected outright (warning surfaced
 * to the drag tooltip).
 * On `resize-start` / `resize-end` the constraint clamps the moving edge
 * to the opposite edge so the user can't shrink past zero duration.
 */
export class StartBeforeEndConstraint implements DragConstraint {
  readonly id = 'streamlain.gantt.constraint.start-before-end';
  readonly priority = 0;

  validate(proposed: BarState, ctx: ConstraintCtx): ConstraintResult {
    if (proposed.startMs <= proposed.endMs) {
      return { allowed: true };
    }

    if (ctx.intent === 'resize-start') {
      return {
        allowed: true,
        adjustedState: { ...proposed, startMs: proposed.endMs },
        warning: 'com.streamlain.gantt.drag.warn.clamped-start',
      };
    }

    if (ctx.intent === 'resize-end') {
      return {
        allowed: true,
        adjustedState: { ...proposed, endMs: proposed.startMs },
        warning: 'com.streamlain.gantt.drag.warn.clamped-end',
      };
    }

    return {
      allowed: false,
      warning: 'com.streamlain.gantt.drag.warn.start-after-end',
    };
  }
}
